@if (showMainLayout && !isFullscreenLayout && fontsLoaded) {
  <div class="srm-template srm-template--dashboard">
    <srm-dashboard-sidebar></srm-dashboard-sidebar>
    <div #pageContent class="page-content">
      @if (impersonationState) {
        <div class="impersonation-banner-row">
          <srm-impersonation-banner
            [state]="impersonationState"
            [isStopping]="isStoppingImpersonation"
            (stopImpersonation)="onImpersonationStopClicked()"
          ></srm-impersonation-banner>
        </div>
      }
      <srm-dashboard-header
        [pageTitle]="pageTitle"
        [pageSubtitle]="pageSubtitle"
        [buttonConfig]="headerButtonConfig"
        [secondaryButtonConfig]="secondaryHeaderButtonConfig"
        (headerButtonClick)="onHeaderButtonClicked()"
        (secondaryHeaderButtonClick)="onSecondaryHeaderButtonClicked()"
      >
      </srm-dashboard-header>
      <section class="router-content">
        <router-outlet></router-outlet>
      </section>

      <srm-contact />
    </div>
  </div>
} @else if (isFullscreenLayout) {
  <router-outlet></router-outlet>
} @else {
  <div class="loading-container">
    <srm-loading-spinner />
  </div>
}
